module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/glyphicons-halflings-regular.woff
// module id = A16r
// module chunks = 0